import styled, { css } from 'styled-components';

const shouldForwardProp = prop => !['isActive', 'header', 'fullWidth'].includes(prop);

export const AutoCompleteStyled = styled.div.withConfig({
  shouldForwardProp,
})`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  width: ${props => (props.fullWidth ? '100%' : 'auto')};
`;
export const AutoCompleteInputStyled = styled.div.withConfig({
  shouldForwardProp,
})`
  border-radius: 5px;
  border: 1px solid var(--GrayScale-400);
  background: var(--GrayScale-0);
  display: flex;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 12px;

  ${props =>
    props.isActive &&
    css`
      border-radius: 5px;
      border: 1px solid var(--Primary-500);
      background: var(--GrayScale-0);
    `}

  .auto_input {
    background: var(--GrayScale-0);
    border: none;
    outline: none;
    width: -webkit-fill-available;

    ${props => {
      let styles = '';
      if (props.size == 'small') {
        styles += `
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        `;
      } else if (props.size == 'large') {
        styles += `
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        `;
      }
      return styles;
    }}

    &::placeholder {
      color: var(--GrayScale-500);
    }
  }

  /* header 컴포넌트는 스타일이 다르다.  */
  ${props => {
    const { isActive, header } = props;
    let styles = `

    `;
    if (header) {
      styles += `
        border-radius: 35px;
        background: var(--GrayScale-100);
        .auto_input {
          background: var(--GrayScale-100);
        }
      `;
      if (isActive) {
        styles += `background: var(--GrayScale-100);`;
      }
    }

    return styles;
  }}
`;

export const AutoCompleteBoxStyled = styled.div.withConfig({
  shouldForwardProp,
})`
  z-index: 100;
  padding: 16px;
  border-radius: 10px;
  border: 1px solid var(--GrayScale-400);
  background: var(--GrayScale-0);
  box-shadow: 0px 1px 10px 0px rgba(132, 132, 132, 0.15);
  height: auto;

  position: absolute;
  top: 55px;

  .dataBox {
    max-height: 300px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .dataTextBox {
    padding: 5px 8px;
    cursor: pointer;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
    outline: none;

    &:hover {
      background: var(--Primary-50);
    }

    &:focus,
    &:active {
      background: var(--Primary-50);
      outline: none;
    }
  }
`;
